import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const Info = () => import('./views/Info')

const ROUTE_NAME = 'profile:lesson:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const CREATE = p('create')
const INFO = p('info')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
    }),
    route(':id/info/', Info, INFO, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
      props: true,
    }),
    route('create/', Display, CREATE, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
    }),
    route(':id/detail/', Display, DISPLAY, {
      meta: {
        accessConfig: accessPermission([
          'manager', 'teacher',
        ], options),
      },
      props: true,
    }),
  ]
}
